"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OEmbedLoader_1 = require("../../components/OEmbedLoader");
new OEmbedLoader_1.OEmbedLoader('.instagram-embed', 'jsonp', 'https://api.instagram.com/oembed?url=');
